export const skillsList = {
  0: 'Nenhum',
  1: 'Básico',
  2: 'Intermediário',
  3: 'Avançado',
  4: 'Update',
};
